/**
 * ScoreEditor — centralized copy strings (AOF 25, i18n posture).
 */

export const scoreEditorCopy = {
  nameLabel: "score name",
  descriptionLabel: "measure annotation",
  contentLabel: "voice line",
  namePlaceholder: "name this score",
  descriptionPlaceholder: "what does this score teach?",
  contentPlaceholder: "the voice line — system prompt or score body",
  nameRequiredError: "score name is required",
  readOnlyHint: "read-only — open from the studio to edit",
} as const;
